import { render, staticRenderFns } from "./ErrorComponent.vue?vue&type=template&id=7a93442a&scoped=true"
import script from "./ErrorComponent.vue?vue&type=script&lang=ts"
export * from "./ErrorComponent.vue?vue&type=script&lang=ts"
import style0 from "./ErrorComponent.vue?vue&type=style&index=0&id=7a93442a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a93442a",
  null
  
)

export default component.exports